import React from "react";

const CustomerInsights = () => {
    return (
        <div className="bg-blue-50 dark:bg-gray-900 p-6 rounded-2xl shadow-md max-w-4xl mx-auto mt-10">
            <h2 className="text-2xl font-bold text-blue-900 dark:text-blue-200 mb-4">
                High-Value vs Regular Customer: Key Insights
            </h2>

            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-blue-100 dark:border-gray-700 mb-6">
                <h3 className="text-lg font-semibold text-blue-800 dark:text-blue-300 mb-2">🔍 Key Takeaways:</h3>
                <ul className="list-disc list-inside text-gray-800 dark:text-gray-200 space-y-2">
                    <li><strong>Higher Average Order Value (AOV):</strong> High-value customers spend $7,567 more per order than regular customers.</li>
                    <li><strong>Drop in Recency Score:</strong> Recency score dropped by 2,097 points for high-value customers—indicating less recent purchases.</li>
                    <li><strong>More Items on First Order:</strong> High-value customers purchase 1,396 more items on their first order—implying bulk buying behavior.</li>
                    <li><strong>Higher Value per Item:</strong> They spend $431 more per item compared to regular customers.</li>
                    <li><strong>Higher Minimum Price on First Order:</strong> The entry price for their first order is $159 higher, suggesting a higher threshold to buy.</li>
                    <li><strong>Increased Monetary Score:</strong> A 65-point increase shows improving spending behavior—an opportunity to engage them further.</li>
                </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-green-100 dark:border-green-800">
                <h3 className="text-lg font-semibold text-green-800 dark:text-green-300 mb-2">✅ Recommendations:</h3>
                <ul className="list-disc list-inside text-gray-800 dark:text-gray-200 space-y-2">
                    <li><strong>Target high-value customers</strong> with frequent promotions and personalized offers to maintain loyalty.</li>
                    <li><strong>Offer product bundles or loyalty programs</strong> to increase their average order size.</li>
                    <li><strong>Re-engage declining customers</strong> based on recency drop to prevent churn.</li>
                    <li><strong>Refine pricing strategies</strong> to match their willingness to spend more per item.</li>
                </ul>
            </div>
        </div>

    );
};

export default CustomerInsights;